/**
 * Adoption Claim Form Handler
 * Handles form validation, file upload, and API submission.
 */
(function () {
  'use strict';

  var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
  var ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.pdf'];

  // Find the form on the page
  var form = document.querySelector('.adopt-form');
  if (!form) return;

  var sectionEl = form.closest('.adopt-form-section');
  var sectionId = sectionEl ? sectionEl.id.replace('adopt-form-', '') : '';
  var apiEndpoint = form.dataset.apiEndpoint;

  // Elements
  var fileInput = form.querySelector('.adopt-form__file-input');
  var uploadArea = form.querySelector('.adopt-form__upload');
  var uploadContent = form.querySelector('.adopt-form__upload-content');
  var uploadPreview = form.querySelector('.adopt-form__upload-preview');
  var uploadFilename = form.querySelector('.adopt-form__upload-filename');
  var uploadRemove = form.querySelector('.adopt-form__upload-remove');
  var uploadProgress = form.querySelector('.adopt-form__upload-progress');
  var progressBar = form.querySelector('.adopt-form__upload-progress-bar');
  var errorEl = form.querySelector('.adopt-form__error');
  var submitBtn = form.querySelector('.adopt-form__submit');
  var submitText = form.querySelector('.adopt-form__submit-text');
  var submitLoading = form.querySelector('.adopt-form__submit-loading');
  var successEl = sectionEl ? sectionEl.querySelector('[id^="adopt-success"]') : null;

  var selectedFile = null;

  // -----------------------------------------------------------------------
  // File Upload Handling
  // -----------------------------------------------------------------------

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      if (this.files && this.files[0]) {
        handleFile(this.files[0]);
      }
    });
  }

  // Drag and drop
  if (uploadArea) {
    uploadArea.addEventListener('dragover', function (e) {
      e.preventDefault();
      this.classList.add('adopt-form__upload--dragover');
    });

    uploadArea.addEventListener('dragleave', function () {
      this.classList.remove('adopt-form__upload--dragover');
    });

    uploadArea.addEventListener('drop', function (e) {
      e.preventDefault();
      this.classList.remove('adopt-form__upload--dragover');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        handleFile(e.dataTransfer.files[0]);
      }
    });
  }

  if (uploadRemove) {
    uploadRemove.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearFile();
    });
  }

  // Phone format hint
  var phoneInput = form.querySelector('[name="phone"]');
  var phoneHint = form.querySelector('[id^="adopt-phone-hint"]');
  if (phoneInput && phoneHint) {
    phoneInput.addEventListener('input', function () {
      var v = this.value.replace(/[\s\-()]/g, '');
      if (v.length === 0) {
        phoneHint.textContent = '';
      } else if (v.startsWith('+971')) {
        phoneHint.textContent = v.length < 12 ? 'Keep typing... +971 + 8-9 digits' : '';
      } else if (v.startsWith('05')) {
        var remaining = 10 - v.length;
        phoneHint.textContent = remaining > 0 ? remaining + ' more digit' + (remaining > 1 ? 's' : '') : '';
      } else if (v.startsWith('5')) {
        var remaining = 9 - v.length;
        phoneHint.textContent = remaining > 0 ? remaining + ' more digit' + (remaining > 1 ? 's' : '') : '';
      } else if (/^0[2-9]/.test(v)) {
        phoneHint.textContent = v.length < 9 ? 'Keep typing...' : '';
      } else {
        phoneHint.textContent = 'Use format: 05X XXX XXXX or +971...';
      }
    });
  }

  function handleFile(file) {
    // Validate type
    var ext = '.' + file.name.split('.').pop().toLowerCase();
    if (ALLOWED_TYPES.indexOf(file.type) === -1 && ALLOWED_EXTENSIONS.indexOf(ext) === -1) {
      showError('Please upload a JPG, PNG, or PDF file.');
      return;
    }

    // Validate size
    if (file.size > MAX_FILE_SIZE) {
      showError('File is too large. Maximum size is 10MB.');
      return;
    }

    selectedFile = file;
    hideError();

    // Show preview
    if (uploadContent) uploadContent.style.display = 'none';
    if (uploadPreview) {
      uploadPreview.style.display = 'flex';
      if (uploadFilename) uploadFilename.textContent = file.name;
    }
    if (uploadArea) uploadArea.classList.remove('adopt-form__invalid');
  }

  function clearFile() {
    selectedFile = null;
    if (fileInput) fileInput.value = '';
    if (uploadContent) uploadContent.style.display = 'flex';
    if (uploadPreview) uploadPreview.style.display = 'none';
    if (uploadProgress) uploadProgress.style.display = 'none';
    if (progressBar) progressBar.style.width = '0%';
  }

  // -----------------------------------------------------------------------
  // Validation
  // -----------------------------------------------------------------------

  function validatePhone(value) {
    var cleaned = value.replace(/[\s\-()]/g, '');
    if (/^\+971\d{8,9}$/.test(cleaned)) return true;
    if (/^05\d{8}$/.test(cleaned)) return true;
    if (/^5\d{8}$/.test(cleaned)) return true;
    if (/^0[2-9]\d{7,8}$/.test(cleaned)) return true;
    return false;
  }

  function showFieldError(input, msg) {
    var fieldName = input.name || input.dataset && input.dataset.fieldName || '';
    var errorSpan = form.querySelector('.adopt-form__field-error[data-for="' + fieldName + '"]');
    if (errorSpan) {
      errorSpan.textContent = msg;
      errorSpan.style.display = 'block';
    }
  }

  function hideFieldError(input) {
    var fieldName = input.name || input.dataset && input.dataset.fieldName || '';
    var errorSpan = form.querySelector('.adopt-form__field-error[data-for="' + fieldName + '"]');
    if (errorSpan) {
      errorSpan.textContent = '';
      errorSpan.style.display = 'none';
    }
  }

  function hideAllFieldErrors() {
    var spans = form.querySelectorAll('.adopt-form__field-error');
    spans.forEach(function (s) {
      s.textContent = '';
      s.style.display = 'none';
    });
  }

  function validateForm() {
    var isValid = true;
    hideAllFieldErrors();

    var requiredInputs = form.querySelectorAll('[required]');

    requiredInputs.forEach(function (input) {
      if (input.type === 'file' || input.type === 'checkbox') return;
      input.classList.remove('adopt-form__invalid');

      if (!input.value.trim()) {
        input.classList.add('adopt-form__invalid');
        var label = input.closest('.adopt-form__field') ? input.closest('.adopt-form__field').querySelector('label') : null;
        var fieldLabel = label ? label.textContent.replace('*', '').trim() : 'This field';
        showFieldError(input, fieldLabel + ' is required');
        isValid = false;
        return;
      }

      if (input.type === 'email') {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
          input.classList.add('adopt-form__invalid');
          showFieldError(input, 'Please enter a valid email address');
          isValid = false;
        }
      }

      if (input.name === 'phone') {
        if (!validatePhone(input.value)) {
          input.classList.add('adopt-form__invalid');
          showFieldError(input, 'Enter a UAE number: 05X XXX XXXX or +971 XX XXX XXXX');
          isValid = false;
        }
      }
    });

    // File validation
    if (!selectedFile) {
      if (uploadArea) uploadArea.classList.add('adopt-form__invalid');
      showFieldError({ name: 'certificate' }, 'Please upload your adoption certificate');
      isValid = false;
    }

    // Consent validation
    var consent = form.querySelector('[name="consent"]');
    if (consent && !consent.checked) {
      consent.closest('.adopt-form__consent').classList.add('adopt-form__invalid');
      showFieldError({ name: 'consent' }, 'Please agree to the privacy policy');
      isValid = false;
    }

    return isValid;
  }

  // Clear validation on input
  form.addEventListener('input', function (e) {
    if (e.target.classList.contains('adopt-form__invalid')) {
      e.target.classList.remove('adopt-form__invalid');
    }
    hideFieldError(e.target);
    hideError();
  });

  form.addEventListener('change', function (e) {
    if (e.target.name === 'consent') {
      var label = e.target.closest('.adopt-form__consent');
      if (label) label.classList.remove('adopt-form__invalid');
      hideError();
      hideFieldError(e.target);
    }
  });

  // -----------------------------------------------------------------------
  // Form Submission
  // -----------------------------------------------------------------------

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!validateForm()) {
      showError('Please fix the highlighted fields above.');
      return;
    }

    if (!apiEndpoint) {
      showError('Form endpoint not configured. Please contact support.');
      return;
    }

    submitForm();
  });

  function submitForm() {
    setLoading(true);
    hideError();

    var formData = new FormData();
    formData.append('full_name', form.querySelector('[name="full_name"]').value.trim());
    formData.append('email', form.querySelector('[name="email"]').value.trim());
    formData.append('phone', form.querySelector('[name="phone"]').value.trim());
    formData.append('cat_name', form.querySelector('[name="cat_name"]').value.trim());
    formData.append('rescue_org', form.querySelector('[name="rescue_org"]').value);
    formData.append('adoption_date', form.querySelector('[name="adoption_date"]').value);
    formData.append('street', form.querySelector('[name="street"]').value.trim());
    formData.append('emirate', form.querySelector('[name="emirate"]').value);
    formData.append('area', form.querySelector('[name="area"]').value.trim());
    formData.append('certificate', selectedFile);

    // Honeypot
    var hp = form.querySelector('[name="website"]');
    if (hp) formData.append('website', hp.value);

    // Consent
    var consentInput = form.querySelector('[name="consent"]');
    if (consentInput && consentInput.checked) formData.append('consent', 'on');

    // Show progress
    if (uploadProgress) uploadProgress.style.display = 'block';

    var xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('progress', function (e) {
      if (e.lengthComputable && progressBar) {
        var pct = Math.round((e.loaded / e.total) * 100);
        progressBar.style.width = pct + '%';
      }
    });

    xhr.upload.addEventListener('load', function () {
      if (submitLoading) {
        submitLoading.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><circle cx="10" cy="10" r="8" opacity="0.25"/><path d="M10 2a8 8 0 0 1 8 8" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 10 10" to="360 10 10" dur="0.8s" repeatCount="indefinite"/></path></svg> Processing...';
      }
    });

    xhr.addEventListener('load', function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        showSuccess();
      } else {
        var msg = 'Something went wrong. Please try again.';
        try {
          var res = JSON.parse(xhr.responseText);
          if (res.error) msg = res.error;
        } catch (_) {}
        showError(msg);
        setLoading(false);
      }
    });

    xhr.addEventListener('error', function () {
      showError('Network error. Please check your connection and try again.');
      setLoading(false);
    });

    xhr.open('POST', apiEndpoint);
    xhr.send(formData);
  }

  // -----------------------------------------------------------------------
  // UI Helpers
  // -----------------------------------------------------------------------

  function setLoading(loading) {
    if (submitBtn) submitBtn.disabled = loading;
    if (submitText) submitText.style.display = loading ? 'none' : 'inline';
    if (submitLoading) submitLoading.style.display = loading ? 'inline-flex' : 'none';
  }

  function showError(msg) {
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function hideError() {
    if (errorEl) {
      errorEl.style.display = 'none';
      errorEl.textContent = '';
    }
  }

  function showSuccess() {
    if (form) form.style.display = 'none';
    if (successEl) {
      successEl.style.display = 'flex';
      successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
})();